import { Box, Flex, Typo } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

export interface VehicleRowProps {
  name: string
  value: string | undefined | null
}

export const VehicleRow: FunctionComponent<VehicleRowProps> = ({ name, value }) =>
  value ? (
    <Flex width={1} mt={2}>
      <Box width={[1 / 2, 1 / 3]}>
        <Typo typoSize='sm' color='bodySecondary'>
          {name}
        </Typo>
      </Box>
      <Box width={[1 / 2, 2 / 3]}>
        <Typo typoSize='sm'>{value}</Typo>
      </Box>
    </Flex>
  ) : null
